module.exports = __webpack_public_path__ + "img/W-G14.db505408.jpg";